var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_1522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9212 14.3795L22.9212 0.12943C22.6669 -0.0430994 22.3332 -0.0431872 22.0789 0.12943L1.07889 14.3795C0.873223 14.519 0.75 14.7514 0.75 15V44.25C0.75 44.6642 1.08583 45 1.49997 45H43.5C43.9142 45 44.25 44.6641 44.25 44.25V15C44.2501 14.7514 44.1269 14.519 43.9212 14.3795Z",
    fill: "#F07B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00009 44.2501V15.0001C3.00009 14.7514 3.12331 14.5191 3.32897 14.3795L23.625 0.607116L22.9211 0.12943C22.6668 -0.0430994 22.3331 -0.0431873 22.0789 0.12943L1.07889 14.3795C0.873223 14.5191 0.75 14.7515 0.75 15.0001V44.2501C0.75 44.6643 1.08583 45.0001 1.49997 45.0001H3.74997C3.33583 45.0001 3.00009 44.6644 3.00009 44.2501Z",
    fill: "#E5563C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 18H8.99997C8.58574 18 8.25 18.3358 8.25 18.75V44.2499C8.25 44.6642 8.58583 44.9999 8.99997 44.9999H36C36.4142 44.9999 36.7499 44.6641 36.7499 44.2499V18.7501C36.75 18.3358 36.4142 18 36 18Z",
    fill: "#74757B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99997 18C8.58574 18 8.25 18.3358 8.25 18.75V44.2499C8.25 44.6642 8.58583 44.9999 8.99997 44.9999H10.5V18H8.99997Z",
    fill: "#606268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4999 15H7.49997C7.08574 15 6.75 15.3358 6.75 15.75V18.7499C6.75 19.1642 7.08583 19.4999 7.49997 19.4999H37.4999C37.9142 19.4999 38.2499 19.1641 38.2499 18.7499V15.75C38.2499 15.3358 37.9141 15 37.4999 15Z",
    fill: "#C3C4C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4999 18H7.49997C7.08574 18 6.75 17.6641 6.75 17.25V18.75C6.75 19.1643 7.08583 19.5 7.49997 19.5H37.4999C37.9142 19.5 38.2499 19.1642 38.2499 18.75V17.25C38.2499 17.6643 37.9141 18 37.4999 18Z",
    fill: "#AFB0B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 6.74994H19.5C19.0857 6.74994 18.75 6.41411 18.75 5.99997C18.75 5.58574 19.0858 5.25 19.5 5.25H25.5C25.9142 5.25 26.25 5.58583 26.25 5.99997C26.25 6.4142 25.9141 6.74994 25.5 6.74994Z",
    fill: "#E5563C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 9.74994H19.5C19.0857 9.74994 18.75 9.41411 18.75 8.99997C18.75 8.58583 19.0858 8.25 19.5 8.25H25.5C25.9142 8.25 26.25 8.58583 26.25 8.99997C26.25 9.41411 25.9141 9.74994 25.5 9.74994Z",
    fill: "#E5563C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 12.7499H19.5C19.0857 12.7499 18.75 12.4141 18.75 12C18.75 11.5857 19.0858 11.25 19.5 11.25H25.5C25.9142 11.25 26.25 11.5858 26.25 12C26.25 12.4141 25.9141 12.7499 25.5 12.7499Z",
    fill: "#E5563C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 24H8.99997C8.58574 24 8.25 24.3358 8.25 24.75V33.75C8.25 34.1642 8.58583 34.4999 8.99997 34.4999L13.5 35.2499L18 34.4999C18.4142 34.4999 18.7499 34.1641 18.7499 33.75V24.75C18.75 24.3358 18.4143 24 18 24Z",
    fill: "#FDDD85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 34.5H8.99997C8.58574 34.5 8.25 34.8358 8.25 35.25V44.25C8.25 44.6642 8.58583 44.9999 8.99997 44.9999H18C18.4142 44.9999 18.7499 44.6641 18.7499 44.25V35.25C18.75 34.8358 18.4143 34.5 18 34.5Z",
    fill: "#FDDD85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75003 44.25V35.25C9.75003 34.8357 10.0859 34.5 10.5 34.5H8.99997C8.58574 34.5 8.25 34.8358 8.25 35.25V44.25C8.25 44.6642 8.58583 44.9999 8.99997 44.9999H10.5C10.0858 44.9999 9.75003 44.6643 9.75003 44.25Z",
    fill: "#FDD042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 34.5H12V38.2499C12 38.6642 12.3358 38.9999 12.75 38.9999H14.25C14.6642 38.9999 15 38.6641 15 38.2499V34.5Z",
    fill: "#F2C127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 43.5001H12C11.5857 43.5001 11.25 43.1642 11.25 42.7501C11.25 42.336 11.5858 42.0001 12 42.0001H14.9999C15.4142 42.0001 15.7499 42.336 15.7499 42.7501C15.7499 43.1642 15.4142 43.5001 14.9999 43.5001Z",
    fill: "#74757B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75003 33.75V24.75C9.75003 24.3357 10.0859 24 10.5 24H8.99997C8.58574 24 8.25 24.3358 8.25 24.75V33.75C8.25 34.1642 8.58583 34.4999 8.99997 34.4999H10.5C10.0858 34.5 9.75003 34.1643 9.75003 33.75Z",
    fill: "#FDD042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 24H12V27.75C12 28.1643 12.3358 28.5 12.75 28.5H14.25C14.6642 28.5 15 28.1642 15 27.75V24Z",
    fill: "#F2C127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 33.0001H12C11.5857 33.0001 11.25 32.6642 11.25 32.2501C11.25 31.836 11.5858 31.5001 12 31.5001H14.9999C15.4142 31.5001 15.7499 31.836 15.7499 32.2501C15.7499 32.6642 15.4142 33.0001 14.9999 33.0001Z",
    fill: "#74757B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 34.5H19.5C19.0857 34.5 18.75 34.8358 18.75 35.25V44.25C18.75 44.6642 19.0858 44.9999 19.5 44.9999H28.5C28.9142 44.9999 29.2499 44.6641 29.2499 44.25V35.25C29.2499 34.8358 28.9142 34.5 28.5 34.5Z",
    fill: "#FDDD85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 44.25V35.25C20.25 34.8357 20.5859 34.5 21 34.5H19.5C19.0857 34.5 18.75 34.8358 18.75 35.25V44.25C18.75 44.6642 19.0858 44.9999 19.5 44.9999H21C20.5859 44.9999 20.25 44.6643 20.25 44.25Z",
    fill: "#FDD042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 34.5H22.5V38.2499C22.5 38.6642 22.8358 38.9999 23.25 38.9999H24.75C25.1642 38.9999 25.5 38.6641 25.5 38.2499V34.5H25.5001Z",
    fill: "#F2C127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 43.5001H22.5C22.0857 43.5001 21.75 43.1642 21.75 42.7501C21.75 42.336 22.0858 42.0001 22.5 42.0001H25.4999C25.9142 42.0001 26.2499 42.336 26.2499 42.7501C26.2499 43.1642 25.9142 43.5001 25.5 43.5001Z",
    fill: "#74757B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_1522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.3555b1210e46518e9cf5561ba9fa6dac.svg";
export { ForwardRef as ReactComponent };